import React, { useState, useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import {
  Table,
  CardBody,
  CardTitle,
  Button,
  Col,
  Row,
  UncontrolledAlert,
  Spinner,
} from "reactstrap"
import api from "API/Api"
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation"

const AddMaterialBrand = () => {
  const formRef = useRef(null)
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [material, setMaterial] = useState([])

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
    const response = await api.post("create-material", values)
    if (response.data.success === true) {
      formRef.current.reset()
      setSubmitted(true)
    }
    } catch (error) {

      // Handled by global interceptor

    }

    setLoading(false)
  }

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}>
              <h4>Add Material Brand</h4>
            </Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/materials" className="dashBtn">
                <i className=" fas fa-chevron-left "></i> <b> Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm
            style={{ position: "relative" }}
            className="form-horizontal"
            ref={formRef}
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v, "create")
            }}
          >
            <div className="mb-3">
              <AvField
                name="materialName"
                label="Material Brand Name"
                value=""
                className="form-control"
                type="text"
                required
              />
            </div>

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>Material Brand is Added!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button
                  className="btn btn-primary w-md waves-effect waves-light"
                  type="submit"
                      disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span style={{ paddingLeft: "10px" }}>Adding...</span>
                    </>
                  ) : (
                    <span>Add Material </span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default AddMaterialBrand
